import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=207aadb1&scoped=true&"
import script from "./IdeaItem.vue?vue&type=script&lang=js&"
export * from "./IdeaItem.vue?vue&type=script&lang=js&"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&id=207aadb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207aadb1",
  null
  
)

export default component.exports